import { Autocomplete, Divider, Grid, ListItemIcon, Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import contactStyles from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import popupStyles from "../../../assets/styles/componentStyles/globalPopupStyles.module.scss"
import Required from '../../utility/required';
import GlobalButton from '../../utility/globalButton/button';
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { DataConnectorContext, DataConnectorContextpayload } from '../../../context/dataConnectorContext';
import style from "../../../assets/styles/componentStyles/customApiStyles/customApiStyle.module.scss";
import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import globalStyles from "../../../assets/styles/global.module.scss";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import deleteDoc from "../../../assets/deleteDoc.svg";
import { chatbotListInterface, createDataConnectorAssignementPayload, DataConnectorAssignment, dataConnectorAssignmentType, dataConnectorList } from '../../../models/axiosModel';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { isVoiceAgentDataConnectorAssignment } from './assignVoiceAgentPopup';
import { filterCustomChatbots } from '../../../utils/constants';

interface AssignChatbotPopupProps {
    selectedDataConnector: dataConnectorList,
    setShowAssignedChatbotPopup: React.Dispatch<React.SetStateAction<boolean>>,
} 

const AssignChatbotPopup: React.FC<AssignChatbotPopupProps> = (props) => {

    const { selectedDataConnector, setShowAssignedChatbotPopup } = props;

    const { chatbotList } = useContext(ChatbotContext) as ChatbotContextPayload;
    const { setFlagLoading, handleError} = useContext(UserContext) as UserContextPayload;
    const { dataConnectorAssignmentType, getDataConnectorAssignmentType, assignDataConnectorAssignment, getChatbotDataConnectorList, removeDataConnectorAssignment } = useContext(DataConnectorContext) as DataConnectorContextpayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const isChatbotAssignment = (assignment: DataConnectorAssignment) => !isVoiceAgentDataConnectorAssignment(assignment);

    const getChatbotAssignmentTypeId = () => {
        return dataConnectorAssignmentType.find(
            (assignment: dataConnectorAssignmentType) => assignment.data_connector_assignment_type_name.toLowerCase() === "chatbot"
        )?.data_connector_assignment_type_id ?? 0;
    }

    const [payload, setPayload] = useState<createDataConnectorAssignementPayload>({
        chatbot_data_connector_id: selectedDataConnector?.chatbot_data_connector_id,
        data_connector_assignment_type_id: getChatbotAssignmentTypeId(),
        data_connector_assignment_unique_id: -1,
    });

    const [anchorEl, setAnchorEl] = useState<null | SVGSVGElement>(null);
    const [currentRowIndex, setCurrentRowIndex] = useState<string | null>(null); 
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false); 
    const [selectedChatbot, setSelectedChatbot] = useState<chatbotListInterface | null>(null);

    const handleMenuOpen = (event: React.MouseEvent<SVGSVGElement, MouseEvent>, rowIndex: string) => { 
        event.stopPropagation();
        setCurrentRowIndex(rowIndex);
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setCurrentRowIndex(null);
        setAnchorEl(null);
    }; 

    const menuItem = [
        {
            label: "Remove",
            icon: <img alt="" src={deleteDoc} />,
            action: (chatbot: chatbotListInterface) => { 
                setSelectedChatbot(chatbot);
                setShowDeleteConfirmation(true); 
            }
        }
    ]

    const getDataConnectorAssignmentTypeApiCall = async () => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const res = await getDataConnectorAssignmentType(); 
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    }

    useEffect(() => {
        if(dataConnectorAssignmentType.length == 0){
            getDataConnectorAssignmentTypeApiCall();
        }
    }, []); 

    useEffect(() => {
        setPayload((prevState) => ({
            ...prevState,
            data_connector_assignment_type_id: getChatbotAssignmentTypeId(),
        }));
    }, [dataConnectorAssignmentType]);

    const handleChatbotChange = (value: chatbotListInterface | null) => {
        setPayload((prevState) => ({
            ...prevState, 
            data_connector_assignment_unique_id: value ? Number(value.chatbot_id) : -1,
        }));
    } 

    const checkDisabledAssignBtn = () => {
        if(payload.data_connector_assignment_unique_id == -1){
            return true;
        }
        return false;
    } 

    const handleAssignClick = async () => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const res = await assignDataConnectorAssignment(payload);
        if(res.status){
            showSuccess("Chatbot Assigned Successfully")
            getChatbotDataConnectorList();
        } else{
            handleError(res);
        }
        setShowAssignedChatbotPopup(false);
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    } 

    const handleRemoveChatbotAssignment = async () => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        if(selectedChatbot){
            const data_connector_assignement_id = selectedDataConnector.data_connector_assignment?.find((assignment: DataConnectorAssignment) => isChatbotAssignment(assignment) && assignment.data_connector_assignment_unique_id == Number(selectedChatbot?.chatbot_id))?.data_connector_assignment_id || 1;
            const res = await removeDataConnectorAssignment(data_connector_assignement_id);
            if(res.status){
                showSuccess("Chatbot Removed Successfully")
                await getChatbotDataConnectorList();
            } else{
                handleError(res);
            }
        } 
        setShowAssignedChatbotPopup(false);
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={popupStyles.popupTitleTypography}>{`Assign Chatbot to ${selectedDataConnector?.data_connector_functions?.data_connector_function_name}`}</Typography>
                        </Grid>

                        <Divider className={popupStyles.popupTitleDivider} /> 

                        <Grid item>
                            <Grid container className={popupStyles.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={popupStyles.popupFieldTypography}>Select Chatbot <Required /></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Autocomplete 
                                                className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                                options={filterCustomChatbots(chatbotList)?.filter((chatbot: chatbotListInterface) => !(selectedDataConnector?.data_connector_assignment?.some((assignment: DataConnectorAssignment) => isChatbotAssignment(assignment) && (assignment.data_connector_assignment_unique_id).toString() == chatbot.chatbot_id))) || []}
                                                getOptionLabel={(option: chatbotListInterface) => option.chatbot_name}
                                                value={chatbotList?.find((chatbot: chatbotListInterface) => chatbot.chatbot_id == (payload.data_connector_assignment_unique_id).toString()) || null}
                                                renderInput={(params) => <TextField {...params} placeholder='Select Chatbot' />}
                                                onChange={(_, value: chatbotListInterface | null) => handleChatbotChange(value) }
                                                renderOption={(props, option) => {
                                                    return <li {...props} key={`${option?.chatbot_id}-${option?.chatbot_name}`}>
                                                        {option?.chatbot_name ?? ''}
                                                    </li>
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>           

                        <Grid item>
                            <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"} padding={"20px 0"}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Cancel"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='borderedButtonStyle'
                                        onClick={() => setShowAssignedChatbotPopup(false)}
                                    >
                                    </GlobalButton>
                                </Grid>
                                <Grid item>
                                    <GlobalButton
                                        buttonText={"Assign"}
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='primaryButtonStyle' 
                                        disabled={checkDisabledAssignBtn()}
                                        onClick={() => handleAssignClick() }
                                    >
                                    </GlobalButton>
                                </Grid>
                            </Grid>
                        </Grid> 

                        <Grid item>
                            <Grid container className={popupStyles.popupBodyGridContainer} gap={1}> 
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={style.assignedChatbotText}>Assigned Chatbot</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TableContainer className={`${style.customAPITableContainer} ${style.assignedChatbotTableContainer}`}>
                                                <Table stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Chatbot Name</TableCell>
                                                            <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle} ${style.lastColumnSticky} ${style.tableHeaderMorevertCell}`}></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(chatbotList && chatbotList?.filter((chatbot: chatbotListInterface) => selectedDataConnector?.data_connector_assignment?.some((assignment: DataConnectorAssignment) => isChatbotAssignment(assignment) && (assignment.data_connector_assignment_unique_id).toString() == chatbot.chatbot_id))?.length > 0) ? 
                                                            chatbotList?.filter((chatbot: chatbotListInterface) => selectedDataConnector?.data_connector_assignment?.some((assignment: DataConnectorAssignment) => isChatbotAssignment(assignment) && (assignment.data_connector_assignment_unique_id).toString() == chatbot.chatbot_id)).map((chatbot: chatbotListInterface, index: number) => {
                                                                return (
                                                                    <TableRow key={index} className={`${dashboardStyles.cellRow}`}>
                                                                        <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{chatbot.chatbot_name || ""}</TableCell>
                                                                        <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${style.lastColumnSticky} ${style.moreVertIcon}`} onClick={(e) => e.stopPropagation()}>
                                                                            <MoreVertIcon
                                                                                className={`${globalStyles.clickable}`}
                                                                                onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => handleMenuOpen(e, chatbot.chatbot_id)}
                                                                            />
                                                                            <Menu
                                                                                anchorEl={anchorEl}
                                                                                keepMounted
                                                                                open={Boolean(anchorEl) && chatbot.chatbot_id === currentRowIndex}
                                                                                onClose={handleMenuClose}
                                                                            >
                                                                                {menuItem.map((item, index) => {
                                                                                    return (
                                                                                        <MenuItem
                                                                                            className={`${globalStyles.menuItemStyle} ${globalStyles.secondaryFontSize}`}
                                                                                            key={index}
                                                                                            onClick={() => { handleMenuClose(); item.action(chatbot); }}
                                                                                        >
                                                                                            <ListItemIcon>
                                                                                                {item.icon}
                                                                                            </ListItemIcon>
                                                                                            <span>
                                                                                                {item.label}
                                                                                            </span>
                                                                                        </MenuItem>
                                                                                    );
                                                                                })}
                                                                            </Menu>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })
                                                            : 
                                                            <TableRow className={dashboardStyles.cellRow}>
                                                                <TableCell colSpan={12} className={`${globalStyles.textCenter}`}>
                                                                    No Data Available
                                                                </TableCell>
                                                            </TableRow>
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>   

            {showDeleteConfirmation &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure want to remove ${selectedChatbot?.chatbot_name} chatbot from ${selectedDataConnector?.data_connector_functions?.data_connector_function_name}`}
                    title="Remove Confirmation"
                    primaryButtonText="Remove"
                    open={showDeleteConfirmation}
                    onClose={() => setShowDeleteConfirmation(false)}
                    onDelete={() => {
                        if(selectedChatbot){
                            handleRemoveChatbotAssignment()
                        }
                        setShowDeleteConfirmation(false)
                    }}
                />
            } 
        </>
    )
}

export default AssignChatbotPopup
